module.exports = __webpack_public_path__ + "static/media/slider-3-min.a6e16d58.jpg";